/**
 * 🏆 배지 획득 모달
 * 새로운 배지를 획득했을 때 표시되는 축하 모달
 * 3D 애니메이션 이모지 사용
 */

import React from 'react';
import { createPortal } from 'react-dom';
import { getRarityConfig, BADGE_ICONS } from '../constants/badges';

export default function BadgeModal({ badge, onClose }) {
    if (!badge) return null;

    const rarityConfig = getRarityConfig(badge.rarity);

    // 3D 애니메이션 이모지 이미지 경로 (있으면 사용, 없으면 텍스트 이모지)
    const iconPath = BADGE_ICONS[badge.id];

    return createPortal(
        <div
            className="fixed inset-0 z-[99999] flex items-center justify-center p-4 animate-fade-in"
            onClick={onClose}
        >
            {/* 배경 블러 효과 */}
            <div className="absolute inset-0 bg-black/20 backdrop-blur-sm" />

            <div
                className="relative bg-white rounded-[2.5rem] shadow-2xl max-w-sm w-full overflow-hidden animate-scale-up border-4 border-white"
                onClick={e => e.stopPropagation()}
            >
                {/* 배경 그라디언트 */}
                <div className={`bg-gradient-to-br ${rarityConfig.gradient} p-8 text-center relative overflow-hidden`}>
                    {/* 반짝임 효과 */}
                    <div className="absolute inset-0 opacity-40">
                        <div className="absolute top-4 left-8 w-2 h-2 bg-white rounded-full animate-ping" />
                        <div className="absolute top-12 right-12 w-3 h-3 bg-white rounded-full animate-ping" style={{ animationDelay: '0.1s' }} />
                        <div className="absolute bottom-8 left-16 w-2 h-2 bg-white rounded-full animate-ping" style={{ animationDelay: '0.2s' }} />
                        <div className="absolute top-20 left-1/3 w-1.5 h-1.5 bg-white rounded-full animate-ping" style={{ animationDelay: '0.3s' }} />
                        <div className="absolute bottom-12 right-8 w-2 h-2 bg-white rounded-full animate-ping" style={{ animationDelay: '0.15s' }} />
                    </div>

                    <div className="relative z-10">
                        <div className="flex items-center justify-center gap-2 mb-2">
                            <img src="/images/Party_popper.png" alt="" className="w-6 h-6" />
                            <p className="text-sm font-bold text-gray-500 tracking-wider">새로운 배지 획득!</p>
                            <img src="/images/Party_popper.png" alt="" className="w-6 h-6 scale-x-[-1]" />
                        </div>

                        {/* 배지 아이콘 - 3D 애니메이션 이미지 또는 텍스트 이모지 */}
                        <div className={`w-32 h-32 mx-auto mb-4 rounded-[2rem] bg-white shadow-2xl flex items-center justify-center border-4 ${rarityConfig.borderColor} transform hover:scale-105 transition-transform duration-300`}>
                            {iconPath ? (
                                <img
                                    src={iconPath}
                                    alt={badge.name}
                                    className="w-24 h-24 object-contain"
                                />
                            ) : (
                                <span className="text-6xl">{badge.emoji}</span>
                            )}
                        </div>

                        <h2 className="text-2xl font-black text-gray-900 mb-1 tracking-tight">{badge.name}</h2>
                        <p className="text-gray-600 text-sm mb-4 leading-relaxed">{badge.description}</p>

                        {/* 희귀도 & 포인트 */}
                        <div className="flex items-center justify-center gap-3">
                            <span className={`px-4 py-1.5 rounded-full text-xs font-black ${rarityConfig.bgColor} ${rarityConfig.textColor} border ${rarityConfig.borderColor}`}>
                                ✦ {rarityConfig.name}
                            </span>
                            <span className="text-amber-600 font-black text-sm flex items-center gap-1">
                                <img src="/images/Star.png" alt="" className="w-5 h-5" /> +{badge.points}P
                            </span>
                        </div>
                    </div>
                </div>

                {/* 버튼 */}
                <div className="p-6 bg-white">
                    <button
                        onClick={onClose}
                        className="w-full py-4 bg-[#354F38] text-white font-bold rounded-2xl hover:bg-[#2C3E30] transition-all shadow-lg shadow-[#354F38]/20 active:scale-[0.98] text-lg"
                    >
                        <span className="flex items-center justify-center gap-2">
                            축하받기
                            <img src="/images/Confetti_ball.png" alt="" className="w-6 h-6" />
                        </span>
                    </button>
                    <p className="text-center text-xs text-gray-400 mt-3">
                        프로필에서 모든 배지를 확인하세요
                    </p>
                </div>
            </div>
        </div>,
        document.body
    );
}
